/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Sub_Sport_TrackInputs */

const en_ui_sub_sport_track = /** @type {(inputs: Ui_Sub_Sport_TrackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Track`)
};

const de_ui_sub_sport_track = /** @type {(inputs: Ui_Sub_Sport_TrackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bahn`)
};

/**
* | output |
* | --- |
* | "Track" |
*
* @param {Ui_Sub_Sport_TrackInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_sub_sport_track = /** @type {((inputs?: Ui_Sub_Sport_TrackInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Sub_Sport_TrackInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_sub_sport_track(inputs)
	return de_ui_sub_sport_track(inputs)
});